import { Component, OnDestroy, OnInit, Injector } from '@angular/core';
import { combineLatest, concat, Observable, Subscription } from 'rxjs';
import { filter, mergeMap, debounceTime, map } from 'rxjs/operators';
import {
  RankSortingTypeEnum,
  LoggedComponent,
  LoggerService,
  SeriesAmateursItem,
  SeriesAmateusRankingsLocator,
  ViewDataInterface,
  ViewDataService
} from 'world-archery-lib';
import * as x from 'world-archery-lib';
import { FiltersAmateursRankingService } from '../filters-amateurs-ranking.service';
import { TableAbstractComponent } from '../../../common-page-components/classes/table-abstract-component';
import { OpenRankingIndoorStore } from 'src/app/common-page-components/stores/entities-store/open-ranking-indoor-store';
import { animationsTable } from 'src/app/common-page-components/wa-table/wa-table.component';
@Component({
  selector: 'app-series-amateur-ranking-list',
  templateUrl: './series-amateur-ranking-list.component.html',
  styleUrls: ['./series-amateur-ranking-list.component.scss'],
  animations: animationsTable

})
export class SeriesAmateurRankingListComponent extends TableAbstractComponent
  implements OnInit, OnDestroy {
  headers = [
    { name: 'Ranking', isSortable: true, sortProperty: 'RANKING' },
    { name: 'Name', isSortable: true, sortProperty: 'NAME' },
    { name: 'Club/Team', isSortable: true, sortProperty: 'TEAM' },
    { name: "Points", isSortable: true, sortProperty: 'POINTS' },
    { name: "", isSortable: false },

  ];

  detailHeaders = [
    { name: '', isSortable: false, },
    { name: '', isSortable: false,  },
    { name: '', isSortable: false, },

  ];
  constructor(
    protected logger: LoggerService,
    private injector: Injector,
    protected views: ViewDataService,
    public filter_service: FiltersAmateursRankingService
  ) {
    super(injector, filter_service, new OpenRankingIndoorStore(injector));
    this.filter_service.sortLocator.sortingType='RANKING' as any;
    this.filter_service.sortLocator.asc=true;
  }

  ngOnInit() {
    this.subscriptions.push(this.getDataStream().subscribe(next => {
    }));
  }
  ngOnDestroy(){
    super.ngOnDestroy();
  }
  getDataStream(): Observable<Array<SeriesAmateursItem>> {
    return combineLatest(
      this.reload.asObservable(),
      this.filter_service.orderValue,
      this.filter_service.categoriesCombo.comboData,
      this.filter_service.yearCombo.comboData,
      this.filter_service.textSearch.data(300),
    ).pipe(
      map(([reload, order, category, season, search]) => {
        const params = {
          Year: season ? season.Year : undefined,
          CatCode:category.Cat,
          fText: search.text,
          SortBy: order.sortingSend,
          Detailed:1
        };
        return params;
      }),
      mergeMap(params=> {
        return this.model.requestData(params, this.request_more_data);
      })
    );
  }
}
